import React, { useState, useEffect } from 'react'
import {
  DashboardIcon,
  JobsIcon,
  ResumeIcon,
  NamedUserIcon,
  CompanyProfileIcon,
  DashboardSettingsIcon,
  ArrowIcon,
} from '../icons'
import { Link } from 'gatsby'

const EmployerDashBoardSidebar = ({ location, isDropdown = false }) => {
  const [activeSubMenu, setActiveSubMenu] = useState(null)
  const sideBarLinks = [
    {
      title: 'Dashboard',
      slug: '/employer-dashboard/',
      icon: 'dashboard',
    },
    {
      title: 'Manage Jobs',
      slug: '/employer-dashboard/jobs/manage/',
      icon: 'jobs',
    },
    {
      title: 'Resume Search',
      slug: '/employer-dashboard/resume/search/',
      icon: 'search',
    },
    {
      title: 'Named Users',
      slug: '/employer-dashboard/named-users/',
      icon: 'users',
    },
    {
      title: 'Company Profile',
      slug: '/employer-dashboard/company-profile/',
      icon: 'profile',
    },
    {
      title: 'Account',
      slug: '/employer-dashboard/account/',
      icon: 'settings',
    },
  ]
  const iconHandler = icon => {
    switch (icon) {
      case 'dashboard':
        return <DashboardIcon />

      case 'jobs':
        return <JobsIcon />

      case 'users':
        return <NamedUserIcon />

      case 'search':
        return <ResumeIcon />

      case 'settings':
        return <DashboardSettingsIcon />

      case 'profile':
        return <CompanyProfileIcon />
    }
  }
  useEffect(() => {
    sideBarLinks.forEach((link, index) => {
      if (link.children) {
        let found = link.children.find(
          item => location.pathname.indexOf(item.slug) !== -1
        )
        if (found) {
          setActiveSubMenu(index)
        } else {
          setActiveSubMenu(null)
        }
      }
    })
  }, [location])
  return (
    <div
      className={`w-full px-6 xl:px-12 bg-charcoal py-8 flex ${
        !isDropdown && 'items-center min-h-screen rounded-tr-md rounded-br-md'
      } ${isDropdown ? 'flex-col-reverse' : 'flex-col'}`}
    >
      <Link to="/employer-dashboard/jobs/create/">
        <button
          className={`text-white py-3 px-10 bg-poppy cursor-pointer font-sans font-bold rounded ${
            isDropdown && 'w-full'
          }`}
        >
          Post Job
        </button>
      </Link>
      <ul
        className={`${isDropdown ? 'mt-6' : 'mt-12'} ${isDropdown && 'px-6'}`}
      >
        {sideBarLinks.map((link, linkIndex) => {
          if (!link.children) {
            return (
              <li key={linkIndex} className="block mb-6">
                <Link
                  className={`block hover:text-poppy ${
                    location?.pathname === link.slug
                      ? 'text-poppy'
                      : 'text-white '
                  } font-sans font-semibold text-sm flex items-center`}
                  to={link.slug}
                  target={link.slug}
                >
                  <div className="w-[36px] xl:w-[45px]">
                    {iconHandler(link.icon)}
                  </div>
                  <span className="flex-1">{link.title}</span>
                </Link>
              </li>
            )
          } else {
            return (
              <li className="block mb-6" key={linkIndex}>
                <div
                  className="font-sans font-semibold text-sm flex items-center text-navbarItem cursor-pointer"
                  onClick={() => {
                    if (activeSubMenu === linkIndex) {
                      setActiveSubMenu(null)
                    } else {
                      setActiveSubMenu(linkIndex)
                    }
                  }}
                >
                  <div className="w-[36px] xl:w-[45px]">
                    {iconHandler(link.icon)}
                  </div>
                  <div className="flex-1 flex items-center">
                    <span>{link.title}</span>
                    <div
                      className={`ml-2 ${
                        activeSubMenu === linkIndex ? '' : 'rotate-180'
                      }`}
                    >
                      <ArrowIcon />
                    </div>
                  </div>
                </div>
                <ul
                  className={
                    linkIndex === activeSubMenu
                      ? 'h-max mt-2 ml-[46px]'
                      : 'h-0 overflow-hidden mt-0'
                  }
                >
                  {link.children.map((child, childIndex) => {
                    return (
                      <li className="mb-2" key={childIndex}>
                        <Link
                          className={`${
                            location?.pathname === child.slug
                              ? 'text-white'
                              : 'text-navbarItem'
                          } font-sans font-semibold text-xs flex items-center`}
                          to={child.slug}
                        >
                          <span>{child.title}</span>
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              </li>
            )
          }
        })}
      </ul>
    </div>
  )
}
export default EmployerDashBoardSidebar
